// Admin-configurable storefront theme colors (set from Admin → Settings).
export const THEME_DEFAULTS = {
  bg: "#FFFFFF",
  bg_subtle: "#EFF5F1",
  primary: "#11392A",
  surface_invert: "#0B2E21",
  text_main: "#12211A",
  logo_color: "#11392A",
  header_bg: "#FFFFFF",
};

// One-click preset palettes (seasonal / national occasions)
// Each theme: bg (site), bg_subtle (cards), primary (buttons), surface_invert (banners), text_main, logo_color, header_bg
export const THEME_PRESETS = [
  { key: "luxury_black", ar: "أخضر RARE GROUP", en: "Brand Green",
    colors: { ...THEME_DEFAULTS } },
  { key: "mono_black", ar: "أسود فاخر", en: "Luxury Black",
    colors: { bg: "#FFFFFF", bg_subtle: "#F5F5F6", primary: "#000000", surface_invert: "#0A0A0A", text_main: "#0A0A0A", logo_color: "#000000", header_bg: "#FFFFFF" } },
  { key: "qatari_maroon", ar: "عنابي قطري", en: "Qatari Maroon",
    colors: { bg: "#FDFBF9", bg_subtle: "#F6EEF0", primary: "#8A1538", surface_invert: "#5C0E25", text_main: "#211318", logo_color: "#8A1538", header_bg: "#FDFBF9" } },
  { key: "royal_gold", ar: "ذهبي ملكي", en: "Royal Gold",
    colors: { bg: "#FFFDF8", bg_subtle: "#F7F1E6", primary: "#8B6914", surface_invert: "#1C1608", text_main: "#221B0E", logo_color: "#8B6914", header_bg: "#FFFDF8" } },
  { key: "emerald_green", ar: "أخضر زمردي", en: "Emerald Green",
    colors: { bg: "#FBFDFC", bg_subtle: "#EDF5F0", primary: "#0F5132", surface_invert: "#0A3622", text_main: "#12211A", logo_color: "#0F5132", header_bg: "#FBFDFC" } },
  { key: "royal_blue", ar: "أزرق ملكي", en: "Royal Blue",
    colors: { bg: "#FAFBFE", bg_subtle: "#EEF1F9", primary: "#1E3A8A", surface_invert: "#152A63", text_main: "#141A2B", logo_color: "#1E3A8A", header_bg: "#FAFBFE" } },
  { key: "elegant_rose", ar: "وردي راقٍ", en: "Elegant Rose",
    colors: { bg: "#FEFAFB", bg_subtle: "#FAEDF1", primary: "#9D2449", surface_invert: "#5E1229", text_main: "#26141A", logo_color: "#9D2449", header_bg: "#FEFAFB" } },
  { key: "royal_purple", ar: "بنفسجي فاخر", en: "Royal Purple",
    colors: { bg: "#FCFBFE", bg_subtle: "#F2EEF9", primary: "#5B21B6", surface_invert: "#3B1478", text_main: "#1B142B", logo_color: "#5B21B6", header_bg: "#FCFBFE" } },
  { key: "sunset_orange", ar: "برتقالي غروب", en: "Sunset Orange",
    colors: { bg: "#FFFCFA", bg_subtle: "#FBEFE8", primary: "#C2410C", surface_invert: "#7C2A08", text_main: "#271711", logo_color: "#C2410C", header_bg: "#FFFCFA" } },
  { key: "teal_luxury", ar: "تركوازي", en: "Teal",
    colors: { bg: "#FAFDFD", bg_subtle: "#EBF4F3", primary: "#0F766E", surface_invert: "#0A4F4A", text_main: "#122120", logo_color: "#0F766E", header_bg: "#FAFDFD" } },
  { key: "coffee_brown", ar: "بني قهوة", en: "Coffee Brown",
    colors: { bg: "#FDFBF9", bg_subtle: "#F4EEE8", primary: "#6B4226", surface_invert: "#432A18", text_main: "#241A12", logo_color: "#6B4226", header_bg: "#FDFBF9" } },
  { key: "charcoal_gray", ar: "رمادي فحمي", en: "Charcoal Gray",
    colors: { bg: "#FAFAFB", bg_subtle: "#EFF1F3", primary: "#374151", surface_invert: "#1F2937", text_main: "#171B21", logo_color: "#374151", header_bg: "#FAFAFB" } },
  { key: "classic_red", ar: "أحمر كلاسيكي", en: "Classic Red",
    colors: { bg: "#FFFBFB", bg_subtle: "#FAEEEE", primary: "#B91C1C", surface_invert: "#7A1212", text_main: "#251414", logo_color: "#B91C1C", header_bg: "#FFFBFB" } },
  { key: "midnight_navy", ar: "كحلي ليلي", en: "Midnight Navy",
    colors: { bg: "#FAFBFC", bg_subtle: "#EDF0F4", primary: "#0C4A6E", surface_invert: "#082F49", text_main: "#111C24", logo_color: "#0C4A6E", header_bg: "#FAFBFC" } },
];

const HEX = /^#[0-9a-fA-F]{6}$/;

export function applyAdminTheme(colors) {
  const c = colors || {};
  const css = Object.keys(THEME_DEFAULTS)
    .filter((k) => HEX.test(c[k] || "") && c[k].toUpperCase() !== THEME_DEFAULTS[k].toUpperCase())
    .map((k) => {
      if (k === "header_bg") return `--header-bg: ${c[k]}E6;`; // keep the glass translucency
      return `--${k.replace(/_/g, "-")}: ${c[k]};`;
    });
  if (HEX.test(c.primary || "")) {
    const n = parseInt(c.primary.slice(1), 16);
    const lum = 0.299 * ((n >> 16) & 255) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255);
    css.push(`--on-primary: ${lum > 150 ? "#000000" : "#FFFFFF"};`);
  }
  let el = document.getElementById("admin-theme");
  if (!css.length) { if (el) el.remove(); return; }
  if (!el) {
    el = document.createElement("style");
    el.id = "admin-theme";
    document.head.appendChild(el);
  }
  el.textContent = `:root:not([data-theme="dark"]) { ${css.join(" ")} }`;
}
